import { render, staticRenderFns } from "./MultiplasPerguntas.vue?vue&type=template&id=46d012db&scoped=true&"
import script from "./MultiplasPerguntas.vue?vue&type=script&lang=js&"
export * from "./MultiplasPerguntas.vue?vue&type=script&lang=js&"
import style0 from "./MultiplasPerguntas.vue?vue&type=style&index=0&id=46d012db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d012db",
  null
  
)

export default component.exports